<template>
  <div class="modal info-val">
    <div class="empty" @click="emits('close')"></div>
    <div class="box">
      <div class="top">
        <div class="preco">
          <div class="icon"></div>
          <span>{{ info.price }} asinhas</span>
        </div>
        <div class="stats" v-if="parseInt(info.stats) === 1"><i class="fa-solid fa-arrow-trend-up"></i></div>
        <div class="stats" v-else-if="parseInt(info.stats) === 3"><i class="fa-solid fa-grip-lines"></i></div>
        <div class="stats" v-else><i class="fa-solid fa-arrow-trend-down"></i></div>
        <div class="close" @click="emits('close')"><i class="fa-solid fa-xmark"></i></div>
      </div>
      <div class="content">
        <div class="mobi p-4">
          <div class="img" :style="{backgroundImage: 'url('+info.image+')'}"></div>
        </div>
        <div class="infos">
          <div class="info icon" v-show="info.code !== ''"
               :style="{backgroundImage: 'url(https://images.habblet.city/c_images/album1584/'+info.code+'.gif)'}"></div>
          <div class="info name">
            <span>{{ info.name }}</span>
          </div>
          <div class="info"><span>Lotes:</span>&nbsp;{{ info.lote }}</div>
          <!--					<div class="info score">$core {{ info.ltd }}</div>-->
          <div v-if=" parseInt(info.rare) === 1" class="info comum">{{ parseInt(info.rare) === 1 ? 'Comum' : '' }}</div>
          <div v-if=" parseInt(info.rare) === 2" class="info incomum">{{ parseInt(info.rare) === 2 ? 'Incomum' : '' }}
          </div>
          <div v-if=" parseInt(info.rare) === 3" class="info epico">{{ parseInt(info.rare) === 3 ? 'Épico' : '' }}</div>
          <div v-if=" parseInt(info.rare) === 4" class="info lendario">{{ parseInt(info.rare) === 4 ? 'Lendário' : ''
            }}
          </div>
          <div class="info avatar">
            <div
              :style="{backgroundImage: `url('${avatarUrl(info.user, { action: 'std,crr=', direction: 3, headonly: true, img_format: '', dance: '', effect: '', frame_num: 30 })}')`}"></div>
            <div>Atualizado por <span>{{ info.user }}</span></div>
          </div>
          <br />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import { getMobById, avatarUrl } from '@/services/api.js'
import { ref } from 'vue'

const emits = defineEmits(['close'])
const props = defineProps(['id'])

const info = ref([])

async function getInfo() {
  info.value = await getMobById(props.id) ?? {}
}

getInfo()

</script>

<style scoped>
.info-val .box .close {
  position: absolute;
  right: 0;
  top: 0;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  user-select: none;
}

.info-val .box {
  width: 500px;
  max-width: calc(100vw - 32px);
  position: absolute;
  display: flex;
  flex-wrap: wrap;
}

.info-val .box .top {
  width: 100%;
  height: 40px;
  padding: 0;
  border: 0;
}

.info-val .box .top .preco {
  float: left;
  width: auto;
  height: 36px;
  padding: 0 12px;
  background-color: #F7BD14;
  border-radius: 12px 0 12px 0;
  text-align: center;
  line-height: 36px;
  font-size: 13px;
  font-weight: 800;
  color: rgba(0, 0, 0, .45);
  transition: all .3s ease-in-out;
  user-select: none;
}

.info-val .box .top .preco span {
  float: left;
  width: auto;
  height: 100%;
  margin: 0 0 0 8px;
}

.info-val .box .top .preco .icon {
  float: left;
  width: 15px;
  height: 15px;
  background-image: url('../../assets/asinha.png');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  margin: 11px 0 0 0;
}

.info-val .box .top .stats {
  float: left;
  width: 30px;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  color: #444;
  text-align: center;
  margin: 4px;
  transition: all .3s ease-in-out;
}

.info-val .box .top .stats i.fa-arrow-trend-up {
  color: #2EC044;
}

.info-val .box .top .stats i.fa-arrow-trend-down {
  color: #FF4040;
}

.info-val .box .top .stats i.fa-grip-lines {
  color: #0D93C6;
}

.info-val .box .content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  background: rgb(255, 255, 255);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(232, 232, 232, 1) 100%);
  border-radius: 0 0 12px 12px;
}

.info-val .content .mobi {
  width: 40%;
  height: 100%;
  border-radius: 0 0 0 12px;
  /* background: rgb(255,255,255); */
  /* background: linear-gradient(180deg, rgba(255,255,255,0) 20%, rgba(182,182,182,.2) 100%); */
}

.info-val .content .mobi .img {
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  image-rendering: pixelated;
  height: 100%;
  width: 100%;
  float: left;
}

.info-val .content .infos {
  width: 60%;
  height: 100%;
  padding: 15px 15px 15px 0;
}

.info-val .content .infos .info {
  width: 100%;
  height: 38px;
  min-height: 38px;
  line-height: 20px;
  text-align: center;
  font-size: 13px;
  font-weight: 400;
  border: 1px solid rgba(13, 147, 198, 0.13);
  background-color: #fff;
  border-radius: 22px;
  margin-top: 6px;
  padding: 0 10px;
  transition: all .4s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* .info-val .content .infos .info:hover {background-color: #2EC044;color: #fff;} */
.info-val .content .infos .info span {
  font-weight: 600;
}

.info-val .content .infos .info.name {
  line-height: 30px;
  height: auto;
}

.info-val .content .infos .info.avatar {
  display: flex;
  justify-content: space-evenly;
}

.info-val .content .infos .info.avatar div:first-of-type {
  width: 36px;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center -36px;
}

.info-val .content .infos .info.icon {
  background-repeat: no-repeat;
  background-position: center;
  height: 46px;
}

.info-val .content .infos .info.comum {
  background-color: #cccccc;
  border: 0;
  font-weight: 600;
  color: #444;
  font-size: 14px;
}

.info-val .content .infos .info.incomum {
  background-color: #30AD3D;
  border: 0;
  font-weight: 600;
  color: #fff;
  font-size: 14px;
}

.info-val .content .infos .info.epico {
  background-color: #4E2699;
  border: 0;
  font-weight: 600;
  color: #fff;
  font-size: 14px;
}

.info-val .content .infos .info.lendario {
  background-color: #EDD21F;
  border: 0;
  font-weight: 600;
  color: #fff;
  font-size: 14px;
}
</style>
